import script from "./authenticationList.vue?vue&type=script&setup=true&lang=js"
export * from "./authenticationList.vue?vue&type=script&setup=true&lang=js"

import "./authenticationList.vue?vue&type=style&index=0&id=c7c59d3c&lang=scss"

const __exports__ = script;

export default __exports__